var poll_default = {
  "fontElementMap": "yycmC",
  "container": "gpV3D",
  "fullscreen": "g-Ncj",
  "background_overlay": "YtUnB",
  "with_image": "JwdlG",
  "options": "S4keg",
  "webview": "_6FDmz",
  "grid": "_6i4-F",
  "option": "-qPfM",
  "cta_button": "kflxQ",
  "add_option": "Ta-as",
  "see_more": "bjCXR",
  "list": "hhow6",
  "column": "w-RBM",
  "additional_note": "FODJg",
  "spinner": "W8G1i",
  "spin": "kFbkA",
  "shown": "aCakl",
  "error": "WOpdX"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
